import { render, staticRenderFns } from "./SendDocForm.vue?vue&type=template&id=337ad870"
import script from "./SendDocForm.vue?vue&type=script&lang=js"
export * from "./SendDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports